import React from "react";

import styles from "./services.module.css";
import data from "./data";
import { Container, Button } from "react-bootstrap";
import { MdComputer } from "react-icons/md";
import { FaNetworkWired } from "react-icons/fa";
import { GiCctvCamera } from "react-icons/gi";
import { AiOutlineLaptop } from "react-icons/ai";
import { MdDeveloperMode } from "react-icons/md";
import { BsFillCloudsFill } from "react-icons/bs";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { Link } from "react-router-dom";

function Services() {
  return (
    <section className={styles.services} id="services">
      <Container>
        <div className="title">
          <h2>الخدمات</h2>
        </div>

        <div className={styles.sercices__content}>
          {data.map((el) => (
            <div className={styles.services__item} key={el.id}>
              <div className={styles.services__icon}>
                {el.icon == "computer" && <MdComputer />}
                {el.icon == "network" && <FaNetworkWired />}
                {el.icon == "camera" && <GiCctvCamera />}
                {el.icon == "website" && <AiOutlineLaptop />}
                {el.icon == "develop" && <MdDeveloperMode />}
                {el.icon == "cloud" && <BsFillCloudsFill />}
                {el.icon == "invoice" && <FaFileInvoiceDollar />}
              </div>
              <h6 className={styles.services__name}>{el.name}</h6>
              <p className={styles.services__desc}>
                {el.desc.slice(0, 40) + "..."}
              </p>

              <Link to={`service/${el.id}`}>
                <Button>إقراء المزيد</Button>
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Services;
